import {
    GET_CANDIDATE_HIRE,
    GET_CANDIDATE_HIRE_FAIL,
    GET_CANDIDATE_HIRE_SUCCESS,
    GET_CLIENT_JOBS,
    GET_CLIENT_JOBS_FAIL, GET_CLIENT_JOBS_SUCCESS,
    GET_DASHBOARD_CARDS_DATA,
    GET_DASHBOARD_CARDS_DATA_FAILED,
    GET_DASHBOARD_CARDS_DATA_SUCCESS,
    GET_DASHBOARD_TOTALINTERVIEW_DATA,
    GET_DASHBOARD_TOTALINTERVIEW_DATA_FAILED,
    GET_DASHBOARD_TOTALINTERVIEW_DATA_SUCCESS,
    GET_INTERVIEW_PROCESS_MODAL_DATA,
    GET_INTERVIEW_PROCESS_MODAL_DATA_FAIL
    // GET_UPCOMING_INTERVIEWS_FILTER_DATA_SUCCESS,
    // GET_UPCOMING_INTERVIEWS_FILTER_DATA_FAIL 
    ,
    GET_INTERVIEW_PROCESS_MODAL_DATA_SUCCESS,
    GET_JOBSTATUS_SUGGESTIONS,
    GET_JOBSTATUS_SUGGESTIONS_FAIL,
    GET_JOBSTATUS_SUGGESTIONS_SUCCESS,
    GET_JOB_COMPLETION_STATUS,
    GET_JOB_COMPLETION_STATUS_FAIL,
    GET_JOB_COMPLETION_STATUS_SUCCESS,
    GET_JOB_STATUS_DATA,
    GET_JOB_STATUS_DATA_FAILED,
    GET_JOB_STATUS_DATA_SUCCESS,
    GET_JOB_STATUS_FILTER_DATA,
    GET_NEW_CANDIDATES_DATA,
    GET_NEW_CANDIDATES_DATA_FAILED,
    GET_NEW_CANDIDATES_DATA_SUCCESS,
    GET_PUBLISHED_JOBS,
    GET_PUBLISHED_JOBS_FAILED,
    GET_PUBLISHED_JOBS_SUCCESSFULL,
    GET_RECRUITMENT_DATA,
    GET_RECRUITMENT_DATA_FAILED,
    GET_RECRUITMENT_DATA_SUCCESSFULL,
    GET_RECRUITMENT_REPORT,
    GET_RECRUITMENT_REPORT_FAILED,
    GET_RECRUITMENT_REPORT_SUCCESS,
    GET_UPCOMING_INTERVIEWS_DATA,
    GET_UPCOMING_INTERVIEWS_DATA_FAIL,
    GET_UPCOMING_INTERVIEWS_DATA_SUCCESS,
    GET_UPCOMING_INTERVIEWS_FILTER_DATA,
    GET_UPCOMING_INTERVIEW_SUGGESTIONS,
    GET_UPCOMING_INTERVIEW_SUGGESTIONS_FAIL,
    GET_UPCOMING_INTERVIEW_SUGGESTIONS_SUCCESS,
    GET_UPDATE_INTERVIEW,
    GET_UPDATE_INTERVIEW_FAIL,
    GET_UPDATE_INTERVIEW_SUCCESS
} from './actionTypes';

export const getPublishedJobsData = (customJSON) => {
    return {
        type:GET_PUBLISHED_JOBS,
        payload: {customJSON}
    }
}

export const getPublishedJobsDataSuccessFull = (publishedJobs) => {
    return {
        type: GET_PUBLISHED_JOBS_SUCCESSFULL,
        payload: {publishedJobs}
    }
}

export const  getPublishedJobsDataFailed = (message) => {
    return {
        type:  GET_PUBLISHED_JOBS_FAILED,
        payload: {message}
    }
}


export const getRecruitmentData = ()=>{
    return {
        type: GET_RECRUITMENT_DATA,
        // payload: {tempData}
    }
}

export const getRecruitmentDataSuccessFull = (recruitmentData)=>{
    return {
        type:  GET_RECRUITMENT_DATA_SUCCESSFULL,
        payload: { recruitmentData}
    }
}

export const  getRecruitmentDataFailed = (message) => {
    return {
        type: GET_RECRUITMENT_DATA_FAILED,
        payload: {message}
    }
}

export const getDashboardCardsData = ()=>{
    return {
        type:  GET_DASHBOARD_CARDS_DATA,
        // payload: {tempData}
    }
}

export const getDashboardCardsDataSuccess = (dashboardCardsData)=>{
    return{
        type:GET_DASHBOARD_CARDS_DATA_SUCCESS,
        payload: {dashboardCardsData}
    }
}

export const getDashboardCardsDataFailed = (message)=>{
    return{
        type: GET_DASHBOARD_CARDS_DATA_FAILED ,
        payload: {message}
    }
}

export const getDashboardTotalTnterviewData = () => {
    return{
        type: GET_DASHBOARD_TOTALINTERVIEW_DATA,
    }
}

export const getDashboardTotalTnterviewDataSuccess = (TotalInterviewData) => {
    return{
        type: GET_DASHBOARD_TOTALINTERVIEW_DATA_SUCCESS,
        payload: {TotalInterviewData}
    }
}

export const getDashboardTotalTnterviewDataFailed = (message) => {
    return{
        type: GET_DASHBOARD_TOTALINTERVIEW_DATA_FAILED,
        payload: {message}
    }
}


export const getNewCandidatesData = (tempData) => {
    return {
        type:GET_NEW_CANDIDATES_DATA,
        payload: {tempData}
    }
}

export const getNewCandidatesDataSuccess = ( newCandidatesData) => {
    return {
        type: GET_NEW_CANDIDATES_DATA_SUCCESS,
        payload: { newCandidatesData}
    }
}

export const  getNewCandidatesDataFailed = (message) => {
    return {
        type:   GET_NEW_CANDIDATES_DATA_FAILED ,
        payload: {message}
    }
}

//RecruitmentAnalytics
export const getRecruitmentReport = () => {
    return {
        type:GET_RECRUITMENT_REPORT,
        // payload: {tempData}
    }
}

export const getRecruitmentReportSuccess = ( recruitmentReport) => {
    return {
        type:GET_RECRUITMENT_REPORT_SUCCESS,
        payload: {recruitmentReport}
    }
}

export const  getRecruitmentReportFailed = (message) => {
    return {
        type:GET_RECRUITMENT_REPORT_FAILED ,
        payload: {message}
    }
}


//new dashboard

// job Status Table
export const getJobsStatusData = (jsondata) => {
    return {
        type: GET_JOB_STATUS_DATA,
        payload: {jsondata}
    }
}

export const getJobsStatusDataSuccessFull = (jobStatusData) => {
    return {
        type: GET_JOB_STATUS_DATA_SUCCESS,
        payload: {jobStatusData}
    }
}

export const getJobsStatusDataFailed = (message) => {
    return {
        type:  GET_JOB_STATUS_DATA_FAILED,
        payload: {message}
    }
}


//upcoming interviews table data

export const getUpComingInterviewsData = (jsondata) => {
    return {
        type: GET_UPCOMING_INTERVIEWS_DATA,
        payload: {jsondata}
    }
}

export const  getUpComingInterviewsDataSuccessFull = ( upComingInterview) => {
    return {
        type: GET_UPCOMING_INTERVIEWS_DATA_SUCCESS,
        payload: {upComingInterview}
    }
}

export const getUpComingInterviewsDataFailed = (message) => {
    return {
        type: GET_UPCOMING_INTERVIEWS_DATA_FAIL ,
        payload: {message}
    }
}




export const getJobComplitionStatus = (eachobject) => {
    return {
        type: GET_JOB_COMPLETION_STATUS,
        payload: {eachobject}
    }
}

export const getJobComplitionStatusSuccessFull = (jobComplitionStatus) => {
    return {
        type: GET_JOB_COMPLETION_STATUS_SUCCESS,
        payload: {jobComplitionStatus}
    }
}

export const getJobComplitionStatusFailed = ( jobComplitionError) => {
    return {
        type: GET_JOB_COMPLETION_STATUS_FAIL ,
        payload: { jobComplitionError}
    }
}

export const getUpComingInterviewsFilterData = (jsonData) => {
    return {
        type: GET_UPCOMING_INTERVIEWS_FILTER_DATA,
        payload: {jsonData}
    }
}

export const getJobsStatusFilterData = (jsonData) => {
    return {
        type: GET_JOB_STATUS_FILTER_DATA,
        payload: {jsonData}
    }
}
 

export const updateInterview = (jsonData) => {
    return {
        type: GET_UPDATE_INTERVIEW,
        payload: {jsonData}
    }
}
export const updateInterviewScuccess = (message) => {
    return {
        type: GET_UPDATE_INTERVIEW_SUCCESS,
        payload: {message}
    }
}

export const updateInterviewFail = (errorMessages) => {
    return {
        type: GET_UPDATE_INTERVIEW_FAIL,
        payload: {errorMessages}
    }
}

export const getUpcomingInterviewsSuggestions = (Keyword)=>{
    return{
        type: GET_UPCOMING_INTERVIEW_SUGGESTIONS,
        payload: {Keyword}
    }
}

export const getUpcomingInterviewsSuggestionsSuccess = (suggestionData)=>{
    return{
        type: GET_UPCOMING_INTERVIEW_SUGGESTIONS_SUCCESS,
        payload: {suggestionData}
    }
}

export const getUpcomingInterviewsSuggestionsFail = (suggestionFailMsg)=>{
    return{
        type: GET_UPCOMING_INTERVIEW_SUGGESTIONS_FAIL,
        payload: {suggestionFailMsg}
    }
}

export const getJobStatusSuggestions = (Keyword)=>{
    return{
        type: GET_JOBSTATUS_SUGGESTIONS,
        payload: {Keyword}
    }
}

export const getJobStatusSuggestionsSuccess = (suggestionData)=>{
    return{
        type: GET_JOBSTATUS_SUGGESTIONS_SUCCESS,
        payload: {suggestionData}
    }
}

export const getJobStatusSuggestionsFail = (suggestionFailMsg)=>{
    return{
        type: GET_JOBSTATUS_SUGGESTIONS_FAIL,
        payload: {suggestionFailMsg}
    }
}

//Recruitment agency bar chart actions 

export const getClientJobs = (data)=>{
    return{
        type: GET_CLIENT_JOBS,
        payload: {data}
    }
}

export const getClientJobsSuccess = (data)=>{
    return{
        type: GET_CLIENT_JOBS_SUCCESS,
        payload: {data}
    }
}

export const getClientJobsFail = (data)=>{
    return{
        type: GET_CLIENT_JOBS_FAIL,
        payload: {data}
    }
}

export const getCandidateHired = (data)=>{
    return{
        type: GET_CANDIDATE_HIRE,
        payload: {data}
    }
}

export const getCandidateHiredSuccess = (data)=>{
    return{
        type: GET_CANDIDATE_HIRE_SUCCESS,
        payload: {data}
    }
}

export const getCandidateHiredFail = (data)=>{
    return{
        type: GET_CANDIDATE_HIRE_FAIL,
        payload: {data}
    }
}

//hire process view modal

export const getHireViewModalData = (data)=>{
    return{
        type: GET_INTERVIEW_PROCESS_MODAL_DATA,
        payload: {data}
    }
}

export const getHireViewModalDataSuccess = (data)=>{
    return{
        type: GET_INTERVIEW_PROCESS_MODAL_DATA_SUCCESS,
        payload: {data}
    }
}

export const getHireViewModalDataFail = (data)=>{
    return{
        type: GET_INTERVIEW_PROCESS_MODAL_DATA_FAIL,
        payload: {data}
    }
}
